module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ja.json
// module id = jc8P
// module chunks = 1